import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const Spacer = ({ space }) => {
  const useStyles = makeStyles((theme) => ({
    space: {
      margin: theme.spacing(parseInt(space)),
    },
  }));
  const classes = useStyles();
  return <div className={classes.space}></div>;
};
export default Spacer;
